var _circle, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeneAiIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#E71316"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1075_8575",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 9,
    width: 12,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 9H13V29H25V9Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1075_8575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0058 26.1851C13.0605 24.0554 13.9999 22.2899 15.3927 20.7947C16.9767 19.0954 18.6754 17.5064 20.3249 15.8678C21.8652 14.345 23.1542 12.7561 22.3513 10.323C22.1492 9.71057 22.548 9.15884 23.2525 9.03195C23.9353 8.90505 24.4105 9.21402 24.629 9.85402C25.1697 11.443 25.1096 12.9988 24.334 14.5106C23.613 15.9175 22.5589 17.043 21.4501 18.1299C19.9863 19.5644 18.4788 20.9602 17.0914 22.4664C15.8133 23.8513 14.9776 25.4457 15.562 27.4595C15.7696 28.1713 15.5347 28.7395 14.7646 28.9382C14.0163 29.1313 13.5411 28.7837 13.3062 28.0719C13.1041 27.4595 12.9621 26.8361 13.0004 26.1795L13.0058 26.1851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0006 26.2727C24.9952 26.9733 24.8477 27.6409 24.5855 28.2809C24.3015 28.9596 23.7662 29.103 23.1272 28.9209C22.499 28.7444 22.1986 28.1927 22.3734 27.6409C23.0944 25.3844 22.073 23.7016 20.6529 22.1899C20.1722 21.6768 20.2651 21.3954 20.5 21.1637C20.6911 20.9761 21.3411 20.3637 21.4503 20.2754C21.7125 20.0658 22.002 20.0547 22.4007 20.5182C23.8318 22.1899 24.9296 23.983 25.0061 26.2671L25.0006 26.2727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6658 10.3723C14.8792 12.4964 15.8242 14.0744 17.2443 15.404C17.8506 15.9723 17.6813 16.2813 17.3754 16.5571C17.2388 16.684 16.709 17.1916 16.5943 17.2964C16.2939 17.5723 15.9771 17.6771 15.4691 17.0923C13.6448 15.0068 12.3613 12.8109 13.339 9.89782C13.5738 9.1861 14.0709 8.87162 14.8082 9.04817C15.5128 9.2192 15.7969 9.74886 15.6658 10.3723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6143 12.9023H18.4345C17.982 12.9023 17.6152 13.2729 17.6152 13.7299C17.6152 14.187 17.982 14.5575 18.4345 14.5575H19.6143C20.0668 14.5575 20.4336 14.187 20.4336 13.7299C20.4336 13.2729 20.0668 12.9023 19.6143 12.9023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3633 10.1797H17.6924C17.2399 10.1797 16.873 10.5502 16.873 11.0073C16.873 11.4643 17.2399 11.8349 17.6924 11.8349H20.3633C20.8158 11.8349 21.1826 11.4643 21.1826 11.0073C21.1826 10.5502 20.8158 10.1797 20.3633 10.1797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4345 24.8397H19.6143C20.0668 24.8397 20.4336 24.4692 20.4336 24.0122C20.4336 23.5551 20.0668 23.1846 19.6143 23.1846H18.4345C17.982 23.1846 17.6152 23.5551 17.6152 24.0122C17.6152 24.4692 17.982 24.8397 18.4345 24.8397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6874 27.5585H20.3584C20.8108 27.5585 21.1777 27.188 21.1777 26.7309C21.1777 26.2738 20.8108 25.9033 20.3584 25.9033H17.6874C17.235 25.9033 16.8682 26.2738 16.8682 26.7309C16.8682 27.188 17.235 27.5585 17.6874 27.5585Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneAiIcon);
export default __webpack_public_path__ + "static/media/geneAiIcon.6dc9154f6282bc582f78f392168303d0.svg";
export { ForwardRef as ReactComponent };